import { render } from "./OtpVerification.vue?vue&type=template&id=bf7388c8"
import script from "./OtpVerification.vue?vue&type=script&lang=js"
export * from "./OtpVerification.vue?vue&type=script&lang=js"

import "./OtpVerification.vue?vue&type=style&index=0&id=bf7388c8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__